import clsx from 'clsx';
import { X } from 'lucide-react';
import { useSyncExternalStore } from 'react';

export interface Toast {
  id: number;
  text: string;
  tone: 'info' | 'error' | 'ok';
  action?: { label: string; run: () => void };
}

let toasts: Toast[] = [];
let seq = 0;
const subscribers = new Set<() => void>();
const emit = () => subscribers.forEach((fn) => fn());

/** Aviso rápido no canto da tela (some sozinho). */
export function toast(text: string, tone: Toast['tone'] = 'info', action?: Toast['action']): void {
  const id = ++seq;
  toasts = [...toasts, { id, text, tone, action }].slice(-5);
  emit();
  setTimeout(() => dismiss(id), tone === 'error' ? 8_000 : 5_000);
}

function dismiss(id: number): void {
  toasts = toasts.filter((t) => t.id !== id);
  emit();
}

export function Toasts() {
  const list = useSyncExternalStore(
    (fn) => {
      subscribers.add(fn);
      return () => subscribers.delete(fn);
    },
    () => toasts,
  );
  return (
    <div className="pointer-events-none fixed inset-x-2 bottom-2 z-[60] flex flex-col gap-2 md:inset-x-auto md:right-4 md:bottom-4 md:w-80">
      {list.map((t) => (
        <div
          key={t.id}
          className={clsx(
            'pointer-events-auto flex items-start gap-2 rounded-md border px-3 py-2 text-sm shadow-lg',
            t.tone === 'error' ? 'border-danger/40 bg-panel text-danger' : t.tone === 'ok' ? 'border-ok/40 bg-panel' : 'border-border bg-panel',
          )}
        >
          <span className="flex-1">{t.text}</span>
          {t.action && (
            <button
              className="font-medium text-accent hover:underline"
              onClick={() => {
                t.action!.run();
                dismiss(t.id);
              }}
            >
              {t.action.label}
            </button>
          )}
          <button className="text-fg-soft" onClick={() => dismiss(t.id)} aria-label="Fechar aviso">
            <X className="size-3.5" />
          </button>
        </div>
      ))}
    </div>
  );
}
